export interface CustomerConfig {
  showSms       : boolean,
  showVoice     : boolean,
  fixedIP       : boolean,
  showOrders    : boolean
}